import { Component, Vue } from 'vue-property-decorator';
import { GettingFile } from '@/enums';
import { FileService } from '@/services/file';

@Component
export default class GettingFileMixin extends Vue {
  file: Blob | null = null;
  gettingFileError = false;
  gettingFileLoading = false;

  async requestFile(params: Record<string, null | boolean | string | number | string[] | number[]>) {
    this.file = await new FileService().getFile(params);
  }

  doFile(blob: Blob | null, type: GettingFile.Types, fileName: string) {
    if (blob === null) {
      return false;
    }

    const url = type === GettingFile.Types.DOWNLOAD
      ? window.URL.createObjectURL(new Blob([blob]))
      : URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;

    if (type === GettingFile.Types.DOWNLOAD) {
      link.download = fileName;
      document.body.appendChild(link);
    } else {
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    }

    link.click();

    if (type === GettingFile.Types.DOWNLOAD) {
      window.URL.revokeObjectURL(url);
    } else {
      URL.revokeObjectURL(url);
    }

    return true;
  }
}
